var render = function render(){var _vm=this,_c=_vm._self._c;return _c('McButton',{attrs:{"text":_vm.buttonText,"disabled":_vm.disabled,"icon":_vm.icon,"size":"sm","variant":"secondary"},on:{"click":_vm.handleCopyText}})
}
var staticRenderFns = []

export { render, staticRenderFns }